module.exports = __webpack_public_path__ + "media/images/instagram-ad571b51e035c68f1fabfa0b7758b0a3.svg";